import React, { useEffect, useState } from 'react';

const FontDemo: React.FC = () => {
  const [fontsLoaded, setFontsLoaded] = useState<Record<string, boolean>>({
    'Archivo Black': false,
    'Space Grotesk': false,
    'Inter': false
  });

  useEffect(() => {
    // Check if fonts are loaded
    document.fonts.ready.then(() => {
      const fontStatus = { ...fontsLoaded };
      
      // Check each font
      fontStatus['Archivo Black'] = document.fonts.check("12px 'Archivo Black'");
      fontStatus['Space Grotesk'] = document.fonts.check("12px 'Space Grotesk'");
      fontStatus['Inter'] = document.fonts.check("12px 'Inter'");
      
      setFontsLoaded(fontStatus);
    });
  }, []);

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-3xl">This is a heading with Archivo Black</h1>
      <p className="text-lg font-space-grotesk">This is a paragraph with Space Grotesk (default font)</p>
      <p className="text-lg font-archivo">This text is explicitly using Archivo Black</p>
      <p className="text-lg font-inter">This text is using Inter (previous font)</p>
      
      {/* Font Loading Status */}
      <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded">
        <h3 className="text-lg mb-2">Font Loading Status:</h3>
        <ul className="list-disc pl-5">
          <li>Archivo Black: {fontsLoaded['Archivo Black'] ? '✅ Loaded' : '❌ Not Loaded'}</li>
          <li>Space Grotesk: {fontsLoaded['Space Grotesk'] ? '✅ Loaded' : '❌ Not Loaded'}</li>
          <li>Inter: {fontsLoaded['Inter'] ? '✅ Loaded' : '❌ Not Loaded'}</li>
        </ul>
      </div>
      
      <div className="grid grid-cols-2 gap-4 mt-6">
        <div className="p-4 border rounded">
          <h2 className="text-2xl mb-2">Heading with Archivo Black</h2>
          <p className="font-space-grotesk">Paragraph text with Space Grotesk</p>
        </div>
        <div className="p-4 border rounded">
          <h2 className="text-2xl font-sans mb-2">Another heading with Space Grotesk (override)</h2>
          <p className="font-archivo">Paragraph with Archivo Black (override)</p>
        </div>
      </div>
      <div className="mt-8 p-6 bg-gray-50 rounded-lg">
        <h3 className="text-xl mb-4">Font Comparison</h3>
        <div className="grid grid-cols-3 gap-4">
          <div>
            <h4 className="text-lg mb-2">Archivo Black (Headings)</h4>
            <p className="font-archivo">ABCDEFGHIJKLM</p>
            <p className="font-archivo">NOPQRSTUVWXYZ</p>
            <p className="font-archivo">abcdefghijklm</p>
            <p className="font-archivo">nopqrstuvwxyz</p>
            <p className="font-archivo">0123456789</p>
          </div>
          <div>
            <h4 className="text-lg mb-2">Space Grotesk (Body)</h4>
            <p className="font-space-grotesk">ABCDEFGHIJKLM</p>
            <p className="font-space-grotesk">NOPQRSTUVWXYZ</p>
            <p className="font-space-grotesk">abcdefghijklm</p>
            <p className="font-space-grotesk">nopqrstuvwxyz</p>
            <p className="font-space-grotesk">0123456789</p>
          </div>
          <div>
            <h4 className="text-lg mb-2">Inter (Previous Body)</h4>
            <p className="font-inter">ABCDEFGHIJKLM</p>
            <p className="font-inter">NOPQRSTUVWXYZ</p>
            <p className="font-inter">abcdefghijklm</p>
            <p className="font-inter">nopqrstuvwxyz</p>
            <p className="font-inter">0123456789</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FontDemo; 